import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { exitActionKiosk, setLanguage } from "../../../../store/actions";
import logo from '../../../../images/M42_logo.png';
import { IKIOSKModel, IkioskMenuIds } from "../../../../models/kioskModel";
import { getSessionTimeout } from "../../../../helpers/helpersIndex";
import { Ilanguages } from "../../../../models/utilitiesModel";
import { useTranslation } from "react-i18next";

function Header() {
  let dispatch = useDispatch()
      const { t } = useTranslation("translations");
  ;
  const menuType: any = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.selectedPage || undefined);
  const sessionEndtime: number = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.pageTimeout || getSessionTimeout());
  const [count, setCount] = useState(sessionEndtime);
  const loading: boolean = useSelector((state: any) => (state.kioskReducer as IKIOSKModel)?.loading || false);
  const langugae: string = useSelector((state: any) => (state.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
  const clientlogo: string = useSelector((state: any) => (state.kioskReducer as IKIOSKModel)?.clientlogo || logo);
  
  useEffect(() => {
    let subscribe;
    if (!loading && !([IkioskMenuIds.LOGINPAGE, IkioskMenuIds.PROMOTIONALSLIDE].includes(menuType)))
      if (count > 0) {
        subscribe = setTimeout(() => {
          setCount(count - 1);
        }, 1000);
      }
      else if (count === 0) {
        dispatch(exitActionKiosk())
      }
    return () => {
      clearTimeout(subscribe);
    }
  }, [count, menuType, loading, dispatch]);


  useEffect(() => {
    setCount(sessionEndtime);
  }, [menuType, sessionEndtime]);

  const secondsToTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(1, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
  return (
    <>
      {menuType &&
        <header className='Kiosk_header'>
          <img src={clientlogo} alt={t("kiosktranslation.logo" + langugae)} width="200" height="70" />
          <div className="d-flex align-items-center gap-4">
            {(!loading && (![IkioskMenuIds.LOGINPAGE, IkioskMenuIds.PROMOTIONALSLIDE, IkioskMenuIds.LANGUGAEPAGE].includes(menuType))) && <><button type="button" onClick={() =>
              dispatch(setLanguage(langugae === Ilanguages.ENG ? Ilanguages.ARB : Ilanguages.ENG))
            } className="Kiosk_lang_button"><i className="icon_m42kiosk_lang_select"></i><span>{langugae === Ilanguages.ENG ? t("kiosktranslation.arb") : t("kiosktranslation.eng")}</span></button></>}
            {!loading && !([IkioskMenuIds.LOGINPAGE, IkioskMenuIds.PROMOTIONALSLIDE].includes(menuType)) && <span className='Kiosk_timer'>{secondsToTime(count)}</span>}
          </div>
        </header>}
    </>
  )
}
export default React.memo(Header);
